if (document.getElementsByClassName('filter-modal').length > 0) {
  import('../Components/Vanilla/FilterModalController');
}
if (document.getElementById('product-page__read-more')) {
  import('../Components/Vanilla/ReadMoreController');
}
if (
  document.getElementsByClassName('product-detail__purchase-wrapper').length >
    0 ||
  document.getElementsByClassName('product-detail__purchase-container').length >
    0
) {
  import('../Components/Vanilla/AddOrRemoveFromInput');
}
// #scroll-to-products is rendered when the request carries a page parameter. The pager's link to
// page one deliberately carries none - that url is a duplicate of the clean one - so it signals the
// same intent with a fragment, which the server never sees. Keep '#products' in sync with
// PaginationViewModel.cshtml.
if (
  document.getElementById('scroll-to-products') ||
  window.location.hash === '#products'
) {
  import('../Components/Vanilla/ScrollToProducts');
}
if (document.getElementById('toggleMyPagesNavigation')) {
  import('../Components/Vanilla/ToggleMyPagesNavigation');
}
if (document.getElementsByClassName('product__wrapper').length > 0) {
  import('../Components/Vanilla/ObserveProductClickEvent');
}
if (document.getElementById('header')?.dataset.sticky === 'true') {
  import('../Components/Vanilla/StickyHeaderController');
}
